var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpot = function SvgSpot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.823 11.718a6.458 6.458 0 1 1 12.917 0 6.458 6.458 0 0 1-12.917 0M8.282 6.51a5.208 5.208 0 1 0 0 10.416 5.208 5.208 0 0 0 0-10.416",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.905 11.157v-1.033l.775.303c.078.022.146.045.224.045a.64.64 0 0 0 .517-.27.61.61 0 0 0-.045-.763c-.337-.393-.865-.674-1.47-.786v-.056a.628.628 0 1 0-1.258 0v.067c-1.09.202-1.875.92-1.875 1.808 0 .887.786 1.605 1.875 1.807v1.033l-.775-.303a.614.614 0 0 0-.73.225.61.61 0 0 0 .045.763c.337.393.865.674 1.47.786v.056a.628.628 0 1 0 1.258 0v-.067c1.09-.202 1.875-.92 1.875-1.808-.01-.887-.797-1.605-1.886-1.807m-1.246-.169c-.393-.123-.629-.348-.629-.527s.236-.405.629-.528zm1.246 2.504v-1.055c.393.123.629.348.629.527 0 .169-.236.404-.629.528"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.728 4.047a6.459 6.459 0 1 1 9.353 8.877.625.625 0 0 1-.854-.913 5.208 5.208 0 1 0-7.543-7.158.625.625 0 0 1-.956-.806",
    clipRule: "evenodd"
  })));
};
export default SvgSpot;